import React from 'react';
import { motion } from 'framer-motion';

import '../assets/web/assets/mobirise-icons2/mobirise2.css';
import '../assets/bootstrap/css/bootstrap.min.css';
import '../assets/bootstrap/css/bootstrap-grid.min.css';
import '../assets/bootstrap/css/bootstrap-reboot.min.css';
import '../assets/parallax/jarallax.css';
import '../assets/web/assets/gdpr-plugin/gdpr-styles.css';
import '../assets/dropdown/css/style.css';
import '../assets/socicon/css/styles.css';
import '../assets/theme/css/style.css';
import '../assets/mobirise/css/mbr-additional.css';

import Navbar from './components/Navbar';
import Footer from './components/Footer';

import civil from './assets/images/1.jpg';
import iluminacao from './assets/images/2.png';
import transmissao from './assets/images/3.jpg';
import eolica from './assets/images/4.jpg';
import aeroporto from './assets/images/6.jpg';

const fadeUp = {
  hidden: { opacity: 0, y: 28 },
  show: { opacity: 1, y: 0 },
};

const stagger = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.12,
    },
  },
};

const sectionReveal = {
  initial: 'hidden',
  whileInView: 'show',
  viewport: { once: true, amount: 0.18 },
  variants: fadeUp,
  transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1] },
};

function SectionTag({ children, light = false }) {
  return (
    <span
      style={{
        display: 'inline-block',
        marginBottom: '14px',
        fontSize: '0.82rem',
        fontWeight: 700,
        letterSpacing: '1.4px',
        textTransform: 'uppercase',
        color: light ? '#d6a04a' : '#b7832f',
      }}
    >
      {children}
    </span>
  );
}

function SectionTitle({ children, center = false, light = false, maxWidth = '760px' }) {
  return (
    <h2
      style={{
        fontSize: 'clamp(2rem, 3vw, 3.2rem)',
        lineHeight: 1.12,
        fontWeight: 800,
        letterSpacing: '-0.8px',
        color: light ? '#ffffff' : '#0d2e63',
        marginBottom: '18px',
        maxWidth,
        marginLeft: center ? 'auto' : 0,
        marginRight: center ? 'auto' : 0,
      }}
    >
      {children}
    </h2>
  );
}

function SectionText({ children, center = false, light = false, maxWidth = '760px' }) {
  return (
    <p
      style={{
        fontSize: '1.04rem',
        lineHeight: 1.9,
        color: light ? 'rgba(255,255,255,0.78)' : '#5f7088',
        maxWidth,
        margin: center ? '0 auto' : 0,
      }}
    >
      {children}
    </p>
  );
}

function ServiceCard({ service, reverse = false }) {
  return (
    <motion.div
      {...sectionReveal}
      style={{
        background: '#ffffff',
        borderRadius: '30px',
        overflow: 'hidden',
        border: '1px solid rgba(13, 46, 99, 0.06)',
        boxShadow: '0 22px 55px rgba(15, 23, 42, 0.07)',
      }}
    >
      <div className={`row g-0 align-items-stretch ${reverse ? 'flex-row-reverse' : ''}`}>
        <div className="col-lg-5">
          <div style={{ position: 'relative', height: '100%' }}>
            <motion.img
              whileHover={{ scale: 1.03 }}
              transition={{ duration: 0.4 }}
              src={service.image}
              alt={service.title}
              style={{
                width: '100%',
                height: '100%',
                minHeight: '340px',
                objectFit: 'cover',
                display: 'block',
              }}
            />
            <div
              style={{
                position: 'absolute',
                inset: 0,
                background: 'linear-gradient(to top, rgba(8,20,41,0.38), rgba(8,20,41,0.02))',
              }}
            />
          </div>
        </div>

        <div className="col-lg-7">
          <div
            style={{
              padding: '34px 30px',
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            <div
              style={{
                fontSize: '0.76rem',
                fontWeight: 700,
                letterSpacing: '1.2px',
                textTransform: 'uppercase',
                color: '#b7832f',
                marginBottom: '10px',
              }}
            >
              Área de atuação
            </div>

            <h3
              style={{
                fontSize: '1.8rem',
                fontWeight: 800,
                color: '#0d2e63',
                marginBottom: '14px',
                lineHeight: 1.2,
              }}
            >
              {service.title}
            </h3>

            <p
              style={{
                color: '#607089',
                lineHeight: 1.9,
                marginBottom: '22px',
                fontSize: '1rem',
              }}
            >
              {service.description}
            </p>

            <div style={{ display: 'grid', gap: '10px' }}>
              {service.points.map((point, index) => (
                <div
                  key={index}
                  style={{
                    display: 'flex',
                    alignItems: 'flex-start',
                    gap: '10px',
                    color: '#4f617a',
                    lineHeight: 1.7,
                  }}
                >
                  <span
                    style={{
                      width: '8px',
                      height: '8px',
                      borderRadius: '50%',
                      background: '#0d4fb3',
                      marginTop: '10px',
                      flexShrink: 0,
                    }}
                  />
                  <span>{point}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
}

function Servicos() {
  const services = [
    {
      title: 'Saneamento',
      image: civil,
      description:
        'A RealEnergy atua com soluções voltadas à operação, manutenção, construção e ampliação de sistemas de distribuição de água e esgotamento sanitário, contribuindo para a eficiência dos serviços e para a melhoria da infraestrutura essencial.',
      points: [
        'Operação de sistemas e apoio técnico contínuo.',
        'Manutenção preventiva e corretiva de estruturas e equipamentos.',
        'Execução de obras e ampliações em redes de distribuição de água e esgoto.',
        'Atuação com foco em continuidade operacional, eficiência e qualidade da entrega.',
      ],
    },
    {
      title: 'Tecnologia da Informação',
      image: iluminacao,
      description:
        'Nossas soluções em tecnologia apoiam a gestão operacional e a eficiência de sistemas por meio de telemetria, monitoramento e ferramentas digitais desenvolvidas para ampliar controle, visibilidade e resposta em campo.',
      points: [
        'Telemetria de unidades de iluminação pública.',
        'Aplicações mobile para gerenciamento de parques de iluminação pública.',
        'Monitoramento de adutoras e bombas em sistemas de distribuição de água.',
        'Soluções orientadas à integração entre operação, gestão e tecnologia.',
      ],
    },
    {
      title: 'Linhas de Transmissão',
      image: transmissao,
      description:
        'A RealEnergy possui experiência em operação, manutenção, construção e ampliação de linhas de transmissão, atuando com responsabilidade técnica e compromisso com a confiabilidade dos sistemas energéticos.',
      points: [
        'Operação e manutenção de estruturas de transmissão.',
        'Construção e ampliação de linhas de transmissão de 69 kV até 500 kV.',
        'Suporte técnico para ativos estratégicos do setor elétrico.',
        'Atuação com foco em segurança, desempenho e conformidade.',
      ],
    },
    {
      title: 'Iluminação',
      image: iluminacao,
      description:
        'Com forte know-how em gestão de iluminação, a RealEnergy oferece soluções completas para parques de iluminação pública e privada, unindo eficiência energética, estética e funcionalidade operacional.',
      points: [
        'Gestão completa de parques de iluminação.',
        'Projetos de iluminação cênica e decorativa.',
        'Soluções de iluminação industrial.',
        'Projetos de iluminação predial com foco em desempenho e eficiência.',
      ],
    },
    {
      title: 'Energia Eólica',
      image: eolica,
      description:
        'Na área de energia eólica, a RealEnergy executa serviços especializados voltados à operação e manutenção de torres de medição eólica e aerogeradores, apoiando a confiabilidade e a continuidade dos ativos.',
      points: [
        'Operação técnica de estruturas e sistemas associados.',
        'Manutenção de torres de medição eólica.',
        'Serviços em aerogeradores com suporte especializado.',
        'Atuação orientada à disponibilidade e ao desempenho operacional.',
      ],
    },
    {
      title: 'Aeroportos',
      image: aeroporto,
      description:
        'A empresa também atua na operação e manutenção completa das engenharias aeroportuárias, apoiando ambientes críticos que exigem alto nível de organização, segurança e desempenho técnico.',
      points: [
        'Operação e manutenção de sistemas de engenharia aeroportuária.',
        'Suporte técnico em ambientes de elevada criticidade operacional.',
        'Atuação com organização, continuidade e confiabilidade.',
        'Compromisso com segurança, desempenho e conformidade institucional.',
      ],
    },
  ];

  const differentials = [
    {
      title: 'Atuação multissetorial',
      text: 'Serviços estruturados para atender diferentes frentes de energia, infraestrutura e operação especializada.',
    },
    {
      title: 'Capacidade técnica',
      text: 'Experiência acumulada em projetos, operações e sistemas que exigem segurança, organização e desempenho.',
    },
    {
      title: 'Compromisso com resultado',
      text: 'Soluções desenvolvidas com foco em qualidade da entrega, eficiência operacional e relacionamento de longo prazo.',
    },
  ];

  return (
    <div
      style={{
        background: 'linear-gradient(180deg, #f3f6fb 0%, #ffffff 30%, #f7f9fc 100%)',
        color: '#11233e',
        fontFamily: 'Arial, sans-serif',
        overflow: 'hidden',
      }}
    >
      <Navbar />

      <section
        style={{
          position: 'relative',
          minHeight: '72vh',
          display: 'flex',
          alignItems: 'center',
          backgroundImage: `linear-gradient(95deg, rgba(8,20,41,0.95) 0%, rgba(10,33,70,0.9) 42%, rgba(13,52,110,0.68) 100%), url(${transmissao})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background:
              'radial-gradient(circle at 15% 20%, rgba(255,255,255,0.08), transparent 22%), radial-gradient(circle at 85% 12%, rgba(214,160,74,0.18), transparent 16%)',
          }}
        />

        <div className="container" style={{ position: 'relative', zIndex: 2 }}>
          <div className="row align-items-center g-5">
            <div className="col-lg-7">
              <motion.div {...sectionReveal} style={{ maxWidth: '760px', padding: '50px 0' }}>
                <div
                  style={{
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '10px',
                    padding: '10px 16px',
                    borderRadius: '999px',
                    background: 'rgba(255,255,255,0.08)',
                    border: '1px solid rgba(255,255,255,0.12)',
                    color: 'rgba(255,255,255,0.84)',
                    fontSize: '13px',
                    textTransform: 'uppercase',
                    letterSpacing: '1px',
                    marginBottom: '24px',
                  }}
                >
                  Serviços e soluções
                </div>

                <h1
                  style={{
                    fontSize: 'clamp(2.5rem, 5vw, 4.7rem)',
                    lineHeight: 1.03,
                    fontWeight: 800,
                    letterSpacing: '-1.2px',
                    color: '#ffffff',
                    marginBottom: '22px',
                  }}
                >
                  Soluções técnicas para energia, infraestrutura e operações especializadas.
                </h1>

                <p
                  style={{
                    fontSize: '1.08rem',
                    lineHeight: 1.9,
                    color: 'rgba(255,255,255,0.82)',
                    maxWidth: '650px',
                  }}
                >
                  A RealEnergy reúne experiência, capacidade técnica e visão operacional para atuar em diferentes segmentos,
                  oferecendo serviços estruturados com foco em segurança, eficiência e qualidade de entrega.
                </p>
              </motion.div>
            </div>

            <div className="col-lg-5">
              <motion.div
                initial={{ opacity: 0, y: 34 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.2 }}
                transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1], delay: 0.08 }}
                style={{ position: 'relative', maxWidth: '500px', marginLeft: 'auto' }}
              >
                <motion.div
                  animate={{ y: [0, -8, 0] }}
                  transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }}
                  style={{
                    position: 'relative',
                    background: 'rgba(255,255,255,0.08)',
                    border: '1px solid rgba(255,255,255,0.12)',
                    borderRadius: '30px',
                    padding: '18px',
                    backdropFilter: 'blur(16px)',
                    boxShadow: '0 30px 80px rgba(0,0,0,0.24)',
                  }}
                >
                  <img
                    src={civil}
                    alt="Serviços RealEnergy"
                    style={{
                      width: '100%',
                      height: '420px',
                      objectFit: 'cover',
                      borderRadius: '24px',
                      display: 'block',
                    }}
                  />

                  <motion.div
                    initial={{ opacity: 0, x: -20 }}
                    whileInView={{ opacity: 1, x: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6, delay: 0.25 }}
                    whileHover={{ y: -4 }}
                    style={{
                      position: 'absolute',
                      left: '-20px',
                      bottom: '34px',
                      width: '250px',
                      background: 'rgba(255,255,255,0.97)',
                      borderRadius: '22px',
                      padding: '18px',
                      boxShadow: '0 20px 55px rgba(15, 23, 42, 0.18)',
                    }}
                  >
                    <div
                      style={{
                        fontSize: '0.78rem',
                        color: '#b7832f',
                        textTransform: 'uppercase',
                        letterSpacing: '1px',
                        marginBottom: '8px',
                        fontWeight: 700,
                      }}
                    >
                      Capacidade operacional
                    </div>
                    <div
                      style={{
                        fontWeight: 800,
                        fontSize: '1.12rem',
                        marginBottom: '6px',
                        color: '#0d2e63',
                        lineHeight: 1.3,
                      }}
                    >
                      Atuação técnica em diferentes frentes e setores.
                    </div>
                    <div style={{ color: '#607089', fontSize: '0.95rem', lineHeight: 1.6 }}>
                      Soluções pensadas para apoiar projetos e operações com eficiência e confiabilidade.
                    </div>
                  </motion.div>
                </motion.div>
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      <section style={{ marginTop: '-48px', position: 'relative', zIndex: 3 }}>
        <div className="container">
          <motion.div
            {...sectionReveal}
            style={{
              background: 'rgba(255,255,255,0.95)',
              borderRadius: '28px',
              boxShadow: '0 24px 70px rgba(15, 23, 42, 0.08)',
              border: '1px solid rgba(15, 23, 42, 0.05)',
              padding: '30px',
            }}
          >
            <motion.div
              className="row g-4"
              variants={stagger}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, amount: 0.15 }}
            >
              {differentials.map((item, index) => (
                <div className="col-lg-4" key={index}>
                  <motion.div
                    variants={fadeUp}
                    transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
                    whileHover={{ y: -8, boxShadow: '0 24px 48px rgba(13, 46, 99, 0.08)' }}
                    style={{
                      background: '#ffffff',
                      borderRadius: '22px',
                      padding: '28px 24px',
                      height: '100%',
                      border: '1px solid rgba(13, 46, 99, 0.06)',
                    }}
                  >
                    <div
                      style={{
                        width: '56px',
                        height: '56px',
                        borderRadius: '16px',
                        background: 'linear-gradient(135deg, #edf3ff, #f7efe1)',
                        marginBottom: '18px',
                      }}
                    />

                    <h3
                      style={{
                        fontSize: '1.22rem',
                        fontWeight: 800,
                        marginBottom: '12px',
                        color: '#0d2e63',
                      }}
                    >
                      {item.title}
                    </h3>

                    <p style={{ color: '#607089', lineHeight: 1.8, marginBottom: 0 }}>{item.text}</p>
                  </motion.div>
                </div>
              ))}
            </motion.div>
          </motion.div>
        </div>
      </section>

      <section style={{ padding: '110px 0 110px' }}>
        <div className="container">
          <motion.div {...sectionReveal} className="text-center" style={{ maxWidth: '900px', margin: '0 auto 54px' }}>
            <SectionTag>Áreas de atuação</SectionTag>
            <SectionTitle center maxWidth="900px">
              Serviços desenvolvidos para atender demandas técnicas com qualidade, segurança e visão de longo prazo.
            </SectionTitle>
            <SectionText center maxWidth="840px">
              Nossas soluções são construídas a partir de experiência prática, equipe qualificada e compromisso com resultados consistentes em diferentes segmentos.
            </SectionText>
          </motion.div>

          <div style={{ display: 'grid', gap: '28px' }}>
            {services.map((service, index) => (
              <ServiceCard key={service.title} service={service} reverse={index % 2 !== 0} />
            ))}
          </div>
        </div>
      </section>

      <section style={{ padding: '0 0 110px' }}>
        <div className="container">
          <motion.div
            {...sectionReveal}
            style={{
              position: 'relative',
              overflow: 'hidden',
              borderRadius: '34px',
              padding: '64px 30px',
              backgroundImage: `linear-gradient(135deg, rgba(9,28,59,0.94), rgba(14,63,148,0.9)), url(${aeroporto})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
              textAlign: 'center',
              boxShadow: '0 28px 72px rgba(15, 23, 42, 0.16)',
            }}
          >
            <div
              style={{
                position: 'absolute',
                inset: 0,
                background: 'radial-gradient(circle at top center, rgba(255,255,255,0.1), transparent 28%)',
              }}
            />

            <div style={{ maxWidth: '820px', margin: '0 auto', position: 'relative', zIndex: 2 }}>
              <SectionTag light>Atendimento especializado</SectionTag>
              <SectionTitle light center maxWidth="820px">
                Projetos e operações conduzidos com estrutura, capacidade técnica e compromisso com a entrega.
              </SectionTitle>
              <SectionText light center maxWidth="760px">
                Entre em contato com a RealEnergy para conhecer melhor nossas áreas de atuação e entender como podemos apoiar sua demanda com soluções alinhadas à realidade do seu projeto.
              </SectionText>

              <motion.a
                whileHover={{ y: -2, scale: 1.01 }}
                whileTap={{ scale: 0.98 }}
                href="/contato"
                style={{
                  marginTop: '28px',
                  textDecoration: 'none',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                  padding: '15px 22px',
                  borderRadius: '14px',
                  background: '#ffffff',
                  color: '#0d4fb3',
                  fontWeight: 700,
                  boxShadow: '0 16px 32px rgba(0,0,0,0.12)',
                }}
              >
                Fale com a nossa equipe
              </motion.a>
            </div>
          </motion.div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default Servicos;